// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__30Wc6","notes":"Notes_notes__GfzhM"};